module.exports = __webpack_public_path__ + "assets/Lambda.1cb86b301430a7963f14a10361c3c2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Lambda.png
// module id = 789
// module chunks = 0